import loadable from '@loadable/component';
import LoadingComponentLoadable from '../../components/Loading/Lazy';

const ProfileLoadable = loadable(() => import(/* webpackChunkName: "profile-page" */ './index'), {
  fallback: <LoadingComponentLoadable />,
});

export default ProfileLoadable;
